/* eslint-disable */
export default function initMap() {
    const google = window.google;

    const styles = [
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#e9e9e9',
                },
                {
                    'lightness': 17,
                },
            ],
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5',
                },
                {
                    'lightness': 20,
                },
            ],
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#ffffff',
                },
                {
                    'lightness': 17,
                },
            ],
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#ffffff',
                },
                {
                    'lightness': 29,
                },
                {
                    'weight': 0.2,
                },
            ],
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff',
                },
                {
                    'lightness': 18,
                },
            ],
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff',
                },
                {
                    'lightness': 16,
                },
            ],
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5',
                },
                {
                    'lightness': 21,
                },
            ],
        },
        {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#dedede',
                },
                {
                    'lightness': 21,
                },
            ],
        },
        {
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'on',
                },
                {
                    'color': '#ffffff',
                },
                {
                    'lightness': 16,
                },
            ],
        },
        {
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'saturation': 36,
                },
                {
                    'color': '#333333',
                },
                {
                    'lightness': 40,
                },
            ],
        },
        {
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off',
                },
            ],
        },
        {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f2f2f2',
                },
                {
                    'lightness': 19,
                },
            ],
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#fefefe',
                },
                {
                    'lightness': 20,
                },
            ],
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#fefefe',
                },
                {
                    'lightness': 17,
                },
                {
                    'weight': 1.2,
                },
            ],
        },
    ];

    var mapOptions = {
        zoom: 15,
        center: new google.maps.LatLng(53.341831, -6.261510),
        scrollwheel: false,
        draggable: true,
        styles: styles,
    };

    var mapOptionsCork = {
        zoom: 15,
        center: new google.maps.LatLng(51.8975221, -8.473056100000008),
        scrollwheel: false,
        draggable: true,
        styles: styles,
    };

    var mapOptionsDublin = {
        zoom: 15,
        center: new google.maps.LatLng(53.3429661, -6.261812899999995),
        scrollwheel: false,
        draggable: true,
        styles: styles,
    };

    var mapOptionsVilnius = {
        zoom: 15,
        center: new google.maps.LatLng(54.6891375, 25.268485),
        scrollwheel: false,
        draggable: true,
        styles: styles,
    };

    var mapMarkerImage = {
        url: require('../../images/marker@2x.png'),
        size: new google.maps.Size(37, 52),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 52),
        scaledSize: new google.maps.Size(37, 52),
    };

    if (document.getElementById('contacts-map-beauty-emporium-dublin')) {
        var mainmap = new google.maps.Map(document.getElementById('contacts-map-beauty-emporium-dublin'), mapOptions);
        new google.maps.Marker({
            position: new google.maps.LatLng(53.341831, -6.261510),
            map: mainmap,
            icon: mapMarkerImage,
        });
    }

    if (document.getElementById('contacts-map-fifth-avenue-cork')) {
        var corkmap = new google.maps.Map(document.getElementById('contacts-map-fifth-avenue-cork'), mapOptionsCork);
        new google.maps.Marker({
            position: new google.maps.LatLng(51.8974035, -8.4727714),
            map: corkmap,
            icon: mapMarkerImage,
        });
    }

    if (document.getElementById('contacts-map-boutique-dublin')) {
        var dublinmap = new google.maps.Map(document.getElementById('contacts-map-boutique-dublin'), mapOptionsDublin);
        new google.maps.Marker({
            position: new google.maps.LatLng(53.3429661, -6.261812899999995),
            map: dublinmap,
            icon: mapMarkerImage,
        });
    }

    if (document.getElementById('contacts-map-city-wax-vilnius')) {
        var dublinmap = new google.maps.Map(document.getElementById('contacts-map-city-wax-vilnius'), mapOptionsVilnius);
        new google.maps.Marker({
            position: new google.maps.LatLng(54.6891375, 25.268485),
            map: dublinmap,
            icon: mapMarkerImage,
        });
    }

    if (document.getElementById('contacts-map-city-wax-vilnius-en')) {
        var dublinmap = new google.maps.Map(document.getElementById('contacts-map-city-wax-vilnius-en'), mapOptionsVilnius);
        new google.maps.Marker({
            position: new google.maps.LatLng(54.6891375, 25.268485),
            map: dublinmap,
            icon: mapMarkerImage,
        });
    }
}


// WEBPACK FOOTER //
// ./scripts/util/maps.js